import React from 'react'
import { Box, Typography } from '@mui/material'

interface TagBadgeProps {
  color: string
  label: string
  size?: string
  width?: string | number
}

const TagBadge: React.FC<TagBadgeProps> = ({ color, label, size = '14px', width = 'auto' }) => {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        position: 'relative',
        backgroundColor: color,
        padding: '0 20px 0 10px', // Adjust right padding to ensure space for the hole
        lineHeight: '24px',
        height: '24px',
        color: '#fff',
        fontSize: size,
        fontWeight: 'bold',
        borderRadius: '5px 0 0 5px',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
        textShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
        marginRight: '12px',
        width: width, // Make width adjustable
        '&::before': {
          content: '""',
          position: 'absolute',
          top: '50%',
          right: '5px', // Space between hole and label
          transform: 'translateY(-50%)',
          width: '5px',
          height: '5px',
          backgroundColor: '#fff',
          borderRadius: '50%',
          boxShadow: '-1px -1px 2px rgba(0, 0, 0, 0.4)',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          top: '0',
          right: '-12px',
          width: '0',
          height: '0',
          borderStyle: 'solid',
          borderWidth: '12px 0 12px 12px',
          borderColor: `transparent transparent transparent ${color}`,
        },
      }}
    >
      <Typography
        sx={{
          color: '#fff',
          fontSize: size,
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </Typography>
    </Box>
  )
}

export default TagBadge
